

const PublishModal = ({ show, title, label, onClose = () => {}, onConfirm, confirmText = "Yes, I have", cancelText = "I still need to add more content" }: any) => {
    if (!show) return null;
  
    return (
        <div className="modal fade show d-block" tabIndex={-1} role="dialog" 
        style={{ backgroundColor: 'rgba(0,0,0,0.5)',zIndex: 2000 }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Confirmation</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <strong>{label}</strong>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                            {cancelText || "Cancel"}
                        </button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={() => { onConfirm(); onClose(); }}>
                            {confirmText || "Yes, I have"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublishModal;
